import { fromJS } from 'immutable';

import * as _ from 'lodash';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as requestsActions from '../actions/requests';

import { fetchingState } from '@constants';

// const updateStateArrayItem = (state, action, arrayName, idFieldName) =>
//   state.setIn(
//     [arrayName, 'data'],
//     fromJS(
//       state
//         .getIn([arrayName, 'data'])
//         .toJS()
//         .map(x =>
//           x[idFieldName] === _.get(action, `data.results[0].${idFieldName}`)
//             ? action.data.results[0]
//             : x,
//         ),
//     ),
//   );

const initialState = {
  results: { data: [], state: null },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case requestsActions.SEARCH_MARKET_AREA[START]: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case requestsActions.SEARCH_MARKET_AREA[SUCCESS]: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case requestsActions.SEARCH_MARKET_AREA[ERROR]: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};
